import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MaterialStorecheckingItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialStorecheckingItem'
  }

}